import { useEffect } from "react";
import { useForm } from "react-hook-form";


import classes from "./inventorySpareForm.module.css";
import { FormInput } from "../../../shared/formElements/formInput/FormInput";
import { FormTextarea } from "../../../shared/formElements/formTextarea/FormTextarea";


export const InventorySpareForm = ({
  initialValues,
  onSubmit,
  onApprove,
  isSubmitting,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { isValid },
  } = useForm({
    defaultValues: initialValues,
    mode: "onChange",
  });

  useEffect(() => {
    reset(initialValues);
  }, [initialValues, reset]);

  return (
    <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
      <div className={classes.section}>
        <h3 className={classes.sectionTitle}>
          Seller Information
        </h3>

        <div className={classes.grid}>
          <FormInput
            id="request_id"
            label="Request ID"
            register={register}
            disabled
            validation={{ required: true }}
          />

          <FormInput
            id="seller_name"
            label="Seller Name"
            register={register}
            disabled
            validation={{ required: true }}
          />
        </div>

        <FormTextarea
          id="remarks"
          label="Remarks"
          // placeholder="Remarks"
          register={register}
          validation={{ required: true }}
        />
      </div>

      <div className={classes.actions}>
        {/* APPROVE */}
        <button
          type="button"
          className={classes.approveBtn}
          disabled={isSubmitting}
          onClick={onApprove}
        >
          Approve
        </button>

        {/* REJECT */}
        <button
          type="submit"
          className={classes.submitBtn}
          disabled={isSubmitting || !isValid}
        >
          {isSubmitting ? "Rejecting..." : "Reject"}
        </button>
      </div>
    </form>
  );
};

